// extracted by mini-css-extract-plugin
module.exports = {"header":"modalheader_header__1_Mmq","title":"modalheader_title__1aRgd","closeBtn":"modalheader_closeBtn__2-wh4"};